// extracted by mini-css-extract-plugin
export default {"iconOnClick":"FehDV9z","radius":"ixXMdQa"};